/**
 * Navega para a tela Derrubada — ondas (#picking-waves) com filtro já aplicado
 * (empresa + nº da onda). Consumido em `js/cruds/picking-waves.js` na abertura.
 */

const STORAGE_KEY = 'sial.navigate.waves.filter';

/**
 * @param {{ companyId: string, waveId: number|string }} opts
 */
export function openWavesFiltered({ companyId, waveId })
{
	const cid = String(companyId || '').trim();
	const wid = String(waveId ?? '').trim();
	if (!cid || !wid)
		return;
	const filter = {
		'field-0': 'company_id',
		'operator-0': 'eq',
		'value-0': cid,
		'field-1': 'id',
		'operator-1': 'eq',
		'value-1': wid,
	};
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filter));
	} catch {
		/* ignore */
	}
	location.hash = '#picking-waves';
}

/**
 * @returns {object|null}
 */
export function consumeWavesPendingFilter()
{
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		sessionStorage.removeItem(STORAGE_KEY);
		const data = JSON.parse(raw);
		return data && typeof data === 'object' ? data : null;
	} catch {
		try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
		return null;
	}
}
